import { useAppSelector } from "@sso/hooks/useRedux";
import { selectBilledOperationSummariesQuery } from "@sso/store/slices/billedOperations";

import { useOrganisationSummariesQuery } from "..";

export const useGetBilledOperationOrganisationSummaries = () => {
  const queryParams = useAppSelector(selectBilledOperationSummariesQuery);
  return useOrganisationSummariesQuery(queryParams);
};
